/*
 * pw-projects-search.js — keep Projects searches ON the Projects page (2026-08-02).
 *
 * Paul: "if you are on projects pages there is a search bar and if you enter something it throws
 * you to the generic search with the correct results but no way to search more projects — can we
 * keep them on the project page so search there is restricted to just projects?"
 *
 * Amy's §8b already made the RESULTS scoped (hidden filter.p.product_type on the form). This adds
 * the missing half: intercept the submit, fetch the SAME scoped search URL through Shopify's
 * Section Rendering API (sections/pw-projects-results.liquid), and inject it in place. Repeat
 * searches re-run without leaving; "load more" pages through the identical URL.
 *
 * PROGRESSIVE ENHANCEMENT IS THE POINT. Nothing here replaces the native form: no JS, an old
 * browser, or any failed fetch and the form submits exactly as it does today — scoped results on
 * /search. That fallback is why this is safe to ship, and it is asserted in
 * tests/test_projects_scoped_search_080202.py.
 */
(function () {
  var root = document.querySelector('[data-pw-pj-search-root]');
  if (!root || !window.fetch) return;

  var form = root.querySelector('form[role="search"]');
  var input = root.querySelector('[name="q"]');
  var scopeInput = root.querySelector('[name="filter.p.product_type"]');
  var results = root.querySelector('[data-pw-pj-results]');
  var defaultGrid = root.querySelector('[data-pw-pj-default]');
  var sectionId = root.getAttribute('data-pw-pj-results-section') || 'pw-projects-results';
  if (!form || !input || !results) return;

  var currentQuery = '';

  /** The one URL builder — search route + query + the same product_type scope the native form
   *  carries, rendered through a single section. Page is optional (load more). */
  function searchUrl(query, page) {
    var url = '/search?q=' + encodeURIComponent(query) + '&type=product&section_id=' + encodeURIComponent(sectionId);
    if (scopeInput && scopeInput.value) {
      url += '&filter.p.product_type=' + encodeURIComponent(scopeInput.value);
    }
    if (page && page > 1) url += '&page=' + page;
    return url;
  }

  function setBusy(on) {
    results.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function showResults(html) {
    results.innerHTML = html;
    results.hidden = false;
    if (defaultGrid) defaultGrid.hidden = true;
    if (clearBtn) clearBtn.hidden = false;
    wireLoadMore();
  }

  /** Back to the full, unfiltered project grid — the way out of a search that found nothing. */
  function clearSearch() {
    currentQuery = '';
    input.value = '';
    results.innerHTML = '';
    results.hidden = true;
    if (defaultGrid) defaultGrid.hidden = false;
    if (clearBtn) clearBtn.hidden = true;
    input.focus();
  }

  var clearBtn = root.querySelector('[data-pw-pj-clear]');
  if (clearBtn) {
    clearBtn.hidden = true;
    clearBtn.addEventListener('click', clearSearch);
  }

  /** The results section advertises its next page as data (never a link — a link would navigate
   *  away, which is the exact behaviour this file exists to prevent). */
  function wireLoadMore() {
    var next = results.querySelector('[data-pw-pj-next]');
    if (!next) return;
    var page = parseInt(next.getAttribute('data-pw-pj-next'), 10);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pw-pj__load-more';
    btn.textContent = 'Load more projects';
    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.textContent = 'Loading…';
      fetch(searchUrl(currentQuery, page))
        .then(function (res) { return res.ok ? res.text() : null; })
        .then(function (html) {
          if (!html) throw new Error('load more failed');
          var holder = document.createElement('div');
          holder.innerHTML = html;
          // 2026-08-11: each card is now wrapped in .pw-pj__card-wrap (the <a> plus its sibling
          // pw-card-ctas Add-to-Cart row, item 3) — moving just .pw-pj__card here would append
          // the link but silently drop its cart control on every page past the first.
          var moreCards = holder.querySelectorAll('.pw-pj__card-wrap');
          var grid = results.querySelector('[data-pw-pj-results-grid]');
          if (grid) {
            for (var i = 0; i < moreCards.length; i++) grid.appendChild(moreCards[i]);
          }
          // Swap this page's next-marker for the following one, then re-wire.
          next.parentNode.removeChild(next);
          btn.parentNode.removeChild(btn);
          var newNext = holder.querySelector('[data-pw-pj-next]');
          if (newNext) {
            results.appendChild(newNext);
            wireLoadMore();
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Load more projects';
        });
    });
    results.appendChild(btn);
  }

  form.addEventListener('submit', function (e) {
    var query = (input.value || '').trim();
    if (!query) return; // empty submit: let the browser do whatever it does today
    e.preventDefault();
    currentQuery = query;
    setBusy(true);
    fetch(searchUrl(query, 1))
      .then(function (res) { return res.ok ? res.text() : null; })
      .then(function (html) {
        if (html == null) throw new Error('search failed');
        setBusy(false);
        showResults(html);
      })
      .catch(function () {
        // Fallback: hand the search back to the browser exactly as before this file existed.
        setBusy(false);
        form.submit();
      });
  });
})();
